import { LegalPersonTags } from '@dealstack/shared/lib/generated';

export const TAGS_OPTIONS = [
	{
		value: LegalPersonTags.TARGET,
		label: 'tags.target',
	},
	{
		value: LegalPersonTags.FUND,
		label: 'tags.fund',
	},
	{
		value: LegalPersonTags.CO_INVESTOR,
		label: 'tags.co_investor',
	},
	{
		value: LegalPersonTags.EXTERNAL_LENDER,
		label: 'tags.external_lender',
	},
	{
		value: LegalPersonTags.BID_CO,
		label: 'tags.bid_co',
	},
	{
		value: LegalPersonTags.SPV,
		label: 'tags.spv',
	},
	{
		value: LegalPersonTags.PC_MANAGED,
		label: 'tags.pc_managed',
	},
];
